<template>
  <div v-if="isActive" class="replay-controls">
    <template v-if="replayCompleted">
      <div class="replay-header">
        <span class="replay-title">Replay Complete</span>
      </div>

      <div class="replay-buttons">
        <ion-button @click="restartReplay" expand="block" fill="outline">
          Replay Again
        </ion-button>

        <ion-button @click="exitReplay" expand="block">
          Exit
        </ion-button>
      </div>
    </template>

    <template v-else>
      <div class="replay-header">
        <span class="replay-title">Solution Replay</span>
        <ion-button @click="exitReplay" size="small" fill="clear" color="light">
          <ion-icon :icon="closeOutline" slot="icon-only"></ion-icon>
        </ion-button>
      </div>

      <div class="replay-progress">
        <span class="step-counter">Step {{ currentStep }} / {{ totalSteps }}</span>
      </div>

      <div class="replay-buttons">
        <ion-button
          @click="stepBackward"
          :disabled="!canStepBackward"
          expand="block"
          fill="outline"
        >
          <ion-icon :icon="arrowBackOutline" slot="start"></ion-icon>
          Back
        </ion-button>

        <ion-button
          @click="stepForward"
          :disabled="!canStepForward"
          expand="block"
        >
          Forward
          <ion-icon :icon="arrowForwardOutline" slot="end"></ion-icon>
        </ion-button>
      </div>
    </template>
  </div>
</template>

<script setup>
import { inject, computed } from 'vue';
import { IonButton, IonIcon } from '@ionic/vue';
import { arrowBackOutline, arrowForwardOutline, closeOutline } from 'ionicons/icons';
import { GameEvents } from '../../lib/GameEvents';

const game = inject('game');

const isActive = computed(() => game.state.activePlayMode === 'replay');
const replayCompleted = computed(() => game.state.solutionReplay.replayCompleted);
const currentStep = computed(() => game.state.solutionReplay.currentStepIndex);
const totalSteps = computed(() => game.state.solutionReplay.totalSteps);
const canStepBackward = computed(() => game.state.solutionReplay.canStepBackward);
const canStepForward = computed(() => game.state.solutionReplay.canStepForward);

const stepForward = () => game.emit(GameEvents.SOLUTION_REPLAY_STEP_FORWARD);
const stepBackward = () => game.emit(GameEvents.SOLUTION_REPLAY_STEP_BACKWARD);
const exitReplay = () => game.emit(GameEvents.EXIT_SOLUTION_REPLAY);
const restartReplay = () => game.dispatch(GameEvents.RESTART_GAME);
</script>

<style scoped>
.replay-controls {
  position: fixed;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  background: var(--hw-bg-overlay);
  border: 2px solid var(--hw-border-strong);
  border-radius: var(--hw-radius);
  padding: 16px;
  min-width: 300px;
  z-index: 900;
}

.replay-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.replay-title {
  font-weight: bold;
  color: var(--hw-text);
  font-size: 1.1em;
}

.replay-progress {
  text-align: center;
  margin-bottom: 12px;
  color: var(--hw-text-muted);
  font-size: 0.9em;
}

.step-counter {
  font-family: monospace;
}

.replay-buttons {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}
</style>
